import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import * as api from "./api"

// Events Redux States
import {
  GET_ORGANIZERS,
  GET_ORGANIZER_INFO,
  GET_OWNER_CLUB,
  GET_TOURNAMENTS,
  GET_ORGANIZERS_LOCATIONS,
} from "./actionTypes"

import {
  apiError,
  getOrganizersError,
  getOrganizersLocationsError,
  getOrganizersSuccess,
  getOrganizerInfoFailure,
  getOrganizerInfoSuccess,
  getOwnerClubSuccess,
  getTournamentsFailure,
  getTournamentsSuccess,
  getOrganizersLocationsSuccess,
} from "./actions"

function* getOrganizersLocations({ payload }) {
  try {
    const { data } = yield call(api.getOrganizersLocations, payload)
    yield put(getOrganizersLocationsSuccess(data))
  } catch (error) {
    yield put(getOrganizersLocationsError())
  }
}

function* getOrganizers({ filters, options }) {
  try {
    const { data } = yield call(api.getOrganizers, filters, options)
    yield put(getOrganizersSuccess(data))
  } catch (error) {
    yield put(getOrganizersError())
  }
}

function* getOrganizerInfo({ id }) {
  try {
    const { data } = yield call(api.getOrganizerInfo, id)
    if (!data?.id || String(data.id) !== String(id)) {
      throw new Error("Invalid organizer profile response")
    }
    yield put(getOrganizerInfoSuccess(data, id))
  } catch (error) {
    yield put(getOrganizerInfoFailure(error, id))
  }
}

function* getOwnerClub({ id }) {
  try {
    const { data } = yield call(api.getOwnerClub, id)
    yield put(getOwnerClubSuccess(data))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* getTournaments({ id, options }) {
  try {
    const { data } = yield call(api.getTournaments, id, options)
    yield put(getTournamentsSuccess(data, id))
  } catch (error) {
    yield put(getTournamentsFailure(id))
  }
}

function* eventsSaga() {
  yield takeLatest(GET_ORGANIZERS_LOCATIONS, getOrganizersLocations)
  yield takeLatest(GET_ORGANIZERS, getOrganizers)
  yield takeEvery(GET_ORGANIZER_INFO, getOrganizerInfo)
  yield takeEvery(GET_OWNER_CLUB, getOwnerClub)
  yield takeEvery(GET_TOURNAMENTS, getTournaments)
}

export default eventsSaga
